import type { ReactNode } from 'react'
import { IconoAgendamiento, IconoHoja } from '../../componentes/iconos'
import type { Modo } from '../../hooks/useFiltrosAgendamiento'

/**
 * Conmutador de las formas de agendar. La tabla es el modo por defecto; su panel
 * "Configurar" arma el pedido completo de cada cliente (bono, packs, sueltos,
 * día y extras: dispensador, fianza, portes...), por lo que el antiguo "alta
 * suelta" quedó redundante y se retiró. "Importar Excel" sigue para quien pega
 * una lista. Segmented control, como el toggle Mes/Semana del calendario.
 */

interface Props {
  modo: Modo
  onCambiar: (modo: Modo) => void
}

const MODOS: { clave: Modo; etiqueta: string; icono: ReactNode }[] = [
  { clave: 'tabla', etiqueta: 'Tabla de clientes', icono: <IconoAgendamiento className="size-4" /> },
  { clave: 'masivo', etiqueta: 'Importar Excel', icono: <IconoHoja className="size-4" /> },
]

export function ConmutadorModo({ modo, onCambiar }: Props) {
  return (
    <div
      role="tablist"
      aria-label="Forma de agendar"
      data-tour="agenda-modo"
      className="inline-flex flex-wrap gap-1 rounded-xl border border-borde-fuerte bg-superficie p-1"
    >
      {MODOS.map(({ clave, etiqueta, icono }) => {
        const activo = modo === clave
        return (
          <button
            key={clave}
            type="button"
            role="tab"
            aria-selected={activo}
            onClick={() => onCambiar(clave)}
            className={[
              'flex items-center gap-2 rounded-lg px-3.5 py-2 text-sm font-semibold transition-colors',
              activo
                ? 'bg-acento text-tinta-inversa'
                : 'text-tinta-2 hover:bg-elevado hover:text-tinta',
            ].join(' ')}
          >
            {icono}
            {etiqueta}
          </button>
        )
      })}
    </div>
  )
}
